import './style.scss';
import { HeaderDisplayType, HeaderInteractionType } from '../../../interfaces';
import { useHistory } from 'react-router-dom';

interface Props {
  title?: string | '';
  hideTitle?: boolean;
  goHomeOnBack?: boolean;
  searchQuery?: string;
  displayType: HeaderDisplayType;
  interactionType: HeaderInteractionType;
  closeCallback?: () => void;
  overwriteUrl?: string;
}

const Header = ({
  title,
  hideTitle,
  goHomeOnBack,
  displayType,
  interactionType,
  closeCallback,
  overwriteUrl,
}: Props) => {
  const history = useHistory();

  const CenterContent = () => {
    if (hideTitle) {
      return null;
    }
    return (
      <h1 title={title} className="header-center">
        {title}
      </h1>
    );
  };

  const RightContent = () => {
    return <div className="header-right" />;
  };

  const BackIcon = () => {
    switch (interactionType) {
      case HeaderInteractionType.CloseOnly:
        return <>B</>;
      case HeaderInteractionType.Back:
        return <>B</>;
      default:
        return null;
    }
  };

  const handleBackClick = () => {
    if (closeCallback) {
      return closeCallback();
    }

    if (goHomeOnBack) {
      return history.push('/');
    }

    if (overwriteUrl) {
      return history.push(overwriteUrl);
    }

    history.goBack();
  };

  const LeftContent = () => {
    switch (interactionType) {
      case HeaderInteractionType.Back:
      case HeaderInteractionType.CloseOnly:
        return (
          <div className="header-left">
            <div className="aib-icon backButton" onClick={handleBackClick}>
              <BackIcon />
            </div>
          </div>
        );
      default:
        return <div className="header-left" />;
    }
  };

  return (
    <div className={`header ${displayType}`}>
      <LeftContent />
      <CenterContent />
      <RightContent />
    </div>
  );
};

export default Header;
